/* ════ DRAG TO MOVE ════════════════════════════════════════ */
import { state } from '../state.js';
import { $ } from '../dom.js';
import { addD } from '../utils/date.js';
import { startHalf, endHalf, halfRangeToDates } from './util.js';
import { dbUpdate } from '../supabase/data.js';
import { buildGantt } from './index.js';
import { suppressClick } from './dragguard.js';
import { pushUndo } from './undo.js';
import { showToast } from '../utils/toast.js';

export function startMove(e, tid) {
  e.preventDefault();
  const task = state.tasks.find(t => t.id === tid); if (!task || task.locked) return;
  const ts = $('tl-scroll');
  const HW = state.DAY_W / 2;                       // half-day width, constant for this view
  const durH = endHalf(task) - startHalf(task);     // duration in half-days
  let el = $(`tb-${tid}`);

  // Content-space X (0 = first column's left edge), stable across scroll/paging.
  const contentX = clientX => clientX - ts.getBoundingClientRect().left + ts.scrollLeft;
  // Constant offset (in half-days) from the cursor to the block's start edge.
  const grabOffsetH = Math.round(contentX(e.clientX) / HW) - startHalf(task);

  let moved = false, hoverRes = task.resource;
  let lastX = e.clientX, lastY = e.clientY;
  let pageTimer = null, pageDir = 0;

  // Start position in half-days (relative to current viewStart). Any half-day
  // landing is representable (full/pm/am/pmam), so moves snap to half-days.
  const startHUnder = () => Math.round(contentX(lastX) / HW) - grabOffsetH;

  const place = () => {
    if (!el) return;
    el.style.left = `${startHUnder() * HW + 1}px`;
  };

  const grabEl = () => {
    el = $(`tb-${tid}`);
    if (el) { if (moved) { el.classList.add('dragging'); el.style.pointerEvents = 'none'; } place(); }
  };

  // Page the view in time while the cursor sits at an edge, so a block can be
  // dragged beyond the currently visible window.
  const tick = () => {
    state.viewStart = addD(state.viewStart, pageDir);
    buildGantt();
    grabEl();
  };
  const edgeCheck = () => {
    const r = ts.getBoundingClientRect(), M = 56;
    const dir = lastX > r.right - M ? 1 : (lastX < r.left + M ? -1 : 0);
    if (dir !== pageDir) {
      pageDir = dir;
      if (pageTimer) { clearInterval(pageTimer); pageTimer = null; }
      if (dir) pageTimer = setInterval(tick, 90);
    }
  };

  const onMove = ev => {
    lastX = ev.clientX; lastY = ev.clientY;
    if (!moved && Math.abs(ev.clientX - e.clientX) + Math.abs(ev.clientY - e.clientY) > 4) {
      // A real drag has begun: now take the block out of the hit-test so the
      // drop lands on a lane (and a plain click stays a click → opens editor).
      moved = true;
      if (el) { el.classList.add('dragging'); el.style.pointerEvents = 'none'; }
    }
    el = $(`tb-${tid}`); if (moved) place();
    const lr = document.elementFromPoint(ev.clientX, ev.clientY)?.closest('[data-resource]');
    if (lr?.dataset.resource) hoverRes = lr.dataset.resource;
    edgeCheck();
  };
  const onUp = ev => {
    document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp);
    if (pageTimer) { clearInterval(pageTimer); pageTimer = null; }
    lastX = ev.clientX; lastY = ev.clientY;
    if (el) { el.classList.remove('dragging'); el.style.pointerEvents = ''; }
    if (!moved) return;        // a plain click — let the editor open
    suppressClick();           // swallow the trailing click (even if it lands on another block)
    const s = startHUnder();
    const { start, end, half } = halfRangeToDates(s, s + durH);
    pushUndo({ id: tid, before: { start: task.start, end: task.end, half: task.half, resource: task.resource } });
    dbUpdate(tid, { start, end, half, resource: hoverRes });
    showToast('Moved · Ctrl+Z to undo');
  };
  document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
}
